import React from 'react';

// reference: https://designportal.microsoft.com/media/?resetsearch=&field=metaproperty_Asset_Type&value=Illustrations&viewType=grid#
export const PersonToggleOn = (props) => (
  <svg viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle
      cx="354.875"
      cy="162.607"
      r="40.9604"
      fill="url(#paint0_radial_1315_2021)"
    />
    <circle
      cx="354.875"
      cy="162.607"
      r="40.9604"
      fill="url(#paint1_radial_1315_2021)"
      fillOpacity="0.8"
    />
    <circle
      cx="162.46"
      cy="113.46"
      r="40.9604"
      fill="url(#paint2_linear_1315_2021)"
    />
    <circle cx="162.46" cy="113.46" r="40.9604" fill="#E7E7E7" />
    <circle
      cx="162.46"
      cy="113.46"
      r="40.9604"
      fill="url(#paint3_radial_1315_2021)"
    />
    <path
      d="M268.5 260.5C268.5 242.275 283.275 227.5 301.5 227.5H406.5C424.725 227.5 439.5 242.275 439.5 260.5V324.5C439.5 371.444 400.944 409.5 354 409.5C307.056 409.5 268.5 371.444 268.5 324.5V260.5Z"
      fill="url(#paint4_radial_1315_2021)"
    />
    <path
      d="M268.5 260.5C268.5 242.275 283.275 227.5 301.5 227.5H406.5C424.725 227.5 439.5 242.275 439.5 260.5V324.5C439.5 371.444 400.944 409.5 354 409.5C307.056 409.5 268.5 371.444 268.5 324.5V260.5Z"
      fill="url(#paint5_radial_1315_2021)"
      fillOpacity="0.4"
    />
    <path
      d="M268.5 260.5C268.5 242.275 283.275 227.5 301.5 227.5H406.5C424.725 227.5 439.5 242.275 439.5 260.5V324.5C439.5 371.444 400.944 409.5 354 409.5C307.056 409.5 268.5 371.444 268.5 324.5V260.5Z"
      fill="url(#paint6_linear_1315_2021)"
      fillOpacity="0.3"
    />
    <path
      d="M268.5 260.5C268.5 242.275 283.275 227.5 301.5 227.5H406.5C424.725 227.5 439.5 242.275 439.5 260.5V324.5C439.5 371.444 400.944 409.5 354 409.5C307.056 409.5 268.5 371.444 268.5 324.5V260.5Z"
      fill="url(#paint7_radial_1315_2021)"
      fillOpacity="0.2"
    />
    <path
      d="M268.5 260.5C268.5 242.275 283.275 227.5 301.5 227.5H406.5C424.725 227.5 439.5 242.275 439.5 260.5V324.5C439.5 371.444 400.944 409.5 354 409.5C307.056 409.5 268.5 371.444 268.5 324.5V260.5Z"
      fill="url(#paint8_linear_1315_2021)"
    />
    <path
      d="M268.5 260.5C268.5 242.275 283.275 227.5 301.5 227.5H406.5C424.725 227.5 439.5 242.275 439.5 260.5V324.5C439.5 371.444 400.944 409.5 354 409.5C307.056 409.5 268.5 371.444 268.5 324.5V260.5Z"
      fill="url(#paint9_radial_1315_2021)"
    />
    <path
      d="M268.5 260.5C268.5 242.275 283.275 227.5 301.5 227.5H406.5C424.725 227.5 439.5 242.275 439.5 260.5V324.5C439.5 371.444 400.944 409.5 354 409.5C307.056 409.5 268.5 371.444 268.5 324.5V260.5Z"
      fill="url(#paint10_radial_1315_2021)"
    />
    <path
      d="M245.5 316.5C245.5 334.725 230.725 349.5 212.5 349.5H111.5C93.2746 349.5 78.5 334.725 78.5 316.5L78.5 258C78.5 211.884 115.884 174.5 162 174.5C208.116 174.5 245.5 211.884 245.5 258L245.5 316.5Z"
      fill="url(#paint11_linear_1315_2021)"
    />
    <path
      d="M245.5 316.5C245.5 334.725 230.725 349.5 212.5 349.5H111.5C93.2746 349.5 78.5 334.725 78.5 316.5L78.5 258C78.5 211.884 115.884 174.5 162 174.5C208.116 174.5 245.5 211.884 245.5 258L245.5 316.5Z"
      fill="url(#paint12_radial_1315_2021)"
    />
    <rect
      x="81.5"
      y="374.5"
      width="164"
      height="66"
      rx="33"
      fill="url(#paint13_linear_1315_2021)"
    />
    <rect
      x="81.5"
      y="374.5"
      width="164"
      height="66"
      rx="33"
      fill="url(#paint14_radial_1315_2021)"
      fillOpacity="0.4"
    />
    <rect
      x="81.5"
      y="374.5"
      width="164"
      height="66"
      rx="33"
      fill="url(#paint15_radial_1315_2021)"
    />
    <circle cx="178.13" cy="392.529" r="1" fill="#FFED4E" />
    <circle cx="118.5" cy="419.029" r="1" fill="#FFED4E" />
    <circle cx="111.5" cy="392.529" r="1" fill="#FFED4E" />
    <circle cx="188.5" cy="419.029" r="1" fill="#FFED4E" />
    <circle cx="179.13" cy="407.631" r="1.5" fill="#FFED4E" />
    <circle cx="143.13" cy="406.131" r="1.5" fill="#FFED4E" />
    <circle cx="111" cy="429.131" r="1.5" fill="#FFED4E" />
    <circle cx="128.5" cy="387.305" r="1.5" fill="#FFED4E" />
    <ellipse
      cx="212"
      cy="407.5"
      rx="22.5"
      ry="23"
      fill="url(#paint16_radial_1315_2021)"
    />
    <ellipse
      cx="212"
      cy="407.5"
      rx="22.5"
      ry="23"
      fill="url(#paint17_radial_1315_2021)"
    />
    <ellipse
      cx="212"
      cy="407.5"
      rx="22.5"
      ry="23"
      fill="url(#paint18_radial_1315_2021)"
    />
    <ellipse
      cx="212"
      cy="407.5"
      rx="22.5"
      ry="23"
      fill="url(#paint19_radial_1315_2021)"
      fillOpacity="0.8"
    />
    <ellipse
      cx="212"
      cy="407.5"
      rx="22.5"
      ry="23"
      fill="url(#paint20_radial_1315_2021)"
      fillOpacity="0.5"
    />
    <defs>
      <radialGradient
        id="paint0_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(363.66 144.925) rotate(120.18) scale(83.8863)"
      >
        <stop offset="0.05" stopColor="#E8CCFF" />
        <stop offset="0.23" stopColor="#C594FF" />
        <stop offset="0.36" stopColor="#AD6CFF" />
        <stop offset="0.51" stopColor="#8E42FF" />
        <stop offset="0.78" stopColor="#E0538F" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(354.872 162.64) rotate(97.82) scale(72.7138)"
      >
        <stop offset="0.45" stopColor="white" stopOpacity="0" />
        <stop offset="0.84" stopColor="white" />
      </radialGradient>
      <linearGradient
        id="paint2_linear_1315_2021"
        x1="203.011"
        y1="64.1479"
        x2="156.998"
        y2="188.411"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.344396" stopColor="#E7E7E7" />
        <stop offset="0.936539" stopColor="#D4EB94" />
      </linearGradient>
      <radialGradient
        id="paint3_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(183.085 76.8535) rotate(37.3395) scale(61.0021 57.9899)"
      >
        <stop offset="0.649379" stopColor="#D0D0D0" />
        <stop offset="1" stopColor="#E8E8E8" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(439.5 194.877) rotate(124.75) scale(273.749 193.446)"
      >
        <stop offset="0.0854157" stopColor="#E6C8FF" />
        <stop offset="0.473366" stopColor="#C58FF1" />
        <stop offset="0.698421" stopColor="#A06ED9" />
        <stop offset="0.811094" stopColor="#784ABC" />
        <stop offset="0.925767" stopColor="#CB5285" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(279.9 254.301) rotate(-179.059) scale(155.346 40.7039)"
      >
        <stop offset="0.0544564" stopColor="#7C4EC0" />
        <stop offset="1" stopColor="#9959DB" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint6_linear_1315_2021"
        x1="268.5"
        y1="314.494"
        x2="336.9"
        y2="314.494"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.223958" stopColor="#4F2888" />
        <stop offset="0.833333" stopColor="#7046AE" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint7_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(309.825 308.77) rotate(-179.163) scale(156.767 314.606)"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.510417" stopColor="white" />
        <stop offset="1" stopColor="#FEFEFE" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint8_linear_1315_2021"
        x1="348.3"
        y1="270.174"
        x2="348.3"
        y2="204.734"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C792F2" stopOpacity="0" />
        <stop offset="0.370183" stopColor="#D4B3F8" stopOpacity="0.510417" />
        <stop offset="1" stopColor="#F8EEFF" />
      </linearGradient>
      <radialGradient
        id="paint9_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(373.219 240.303) rotate(180) scale(82.642 9.67905)"
      >
        <stop stopColor="#EFD6FF" />
        <stop offset="1" stopColor="#E6BDFF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(380.288 240.329) rotate(-180) scale(52.0857 8.97886)"
      >
        <stop stopColor="#EFD6FF" />
        <stop offset="1" stopColor="#E6BDFF" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint11_linear_1315_2021"
        x1="211.606"
        y1="174.555"
        x2="99.4225"
        y2="447.188"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.344396" stopColor="#E7E7E7" />
        <stop offset="0.936539" stopColor="#D4EB94" />
      </linearGradient>
      <radialGradient
        id="paint12_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(119 355) rotate(-70.7841) scale(255.22 203.662)"
      >
        <stop offset="0.498297" stopColor="#E8E8E8" stopOpacity="0" />
        <stop offset="0.629917" stopColor="#D0D0D0" />
      </radialGradient>
      <linearGradient
        id="paint13_linear_1315_2021"
        x1="44.5"
        y1="412"
        x2="241.813"
        y2="419.449"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0663151" stopColor="#D4EB94" />
        <stop offset="0.348958" stopColor="#8EE779" />
        <stop offset="0.499981" stopColor="#52DCC6" />
        <stop offset="0.747788" stopColor="#0090FF" />
      </linearGradient>
      <radialGradient
        id="paint14_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(163.5 421.5) rotate(90) scale(45 132)"
      >
        <stop offset="0.444444" stopColor="#9CD271" stopOpacity="0" />
        <stop offset="1" stopColor="#006292" />
      </radialGradient>
      <radialGradient
        id="paint15_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(201.5 422) rotate(124.789) scale(57.8381 39.466)"
      >
        <stop offset="0.122636" stopColor="#004F87" />
        <stop offset="0.510417" stopColor="#0074C6" stopOpacity="0.56" />
        <stop offset="0.621113" stopColor="#0B95F6" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint16_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(215.364 400.91) rotate(120.139) scale(43.2215 42.761)"
      >
        <stop offset="0.103226" stopColor="#C58FF1" />
        <stop offset="0.322917" stopColor="#9D50EE" />
        <stop offset="0.510417" stopColor="#7B30EA" />
        <stop offset="0.78125" stopColor="#CB5285" />
      </radialGradient>
      <radialGradient
        id="paint17_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(215.661 397.567) rotate(104.184) scale(33.9696 33.3208)"
      >
        <stop stopColor="#DAB0F2" />
        <stop offset="0.806053" stopColor="#D1A5EA" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint18_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(216.255 396.656) rotate(122.964) scale(16.1178 15.9772)"
      >
        <stop stopColor="#EDDAFD" />
        <stop offset="0.573279" stopColor="#D8BDEF" stopOpacity="0.57836" />
        <stop offset="1" stopColor="#BC95DC" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint19_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(212 407.5) rotate(97.6474) scale(40.8113 39.9558)"
      >
        <stop offset="0.446038" stopColor="white" stopOpacity="0" />
        <stop offset="0.841379" stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint20_radial_1315_2021"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(211.224 430.5) rotate(-90) scale(16.6552 32.1983)"
      >
        <stop stopColor="#FFB3BB" />
        <stop offset="1" stopColor="#FE625D" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

PersonToggleOn.displayName = 'PersonToggleOn';
